import { message } from 'antd'
import Email from '../../../../api/Email'
import { DeliveryOrderApi } from '../../../../api/Purchase/DeliveryOrder'
import { OrdersApi } from '../../../../api/Purchase/Orders'
import Templates from '../../../../api/Templates'
import AddDeliveryOrder from '../../../../components/Purchasing/DeliveryOrder/AddDeliveryOrder/AddDeliveryOrder'
import useActions from '../../../../elements/Hooks/useActions'
import useFetchList from '../../../../elements/Hooks/useFetchList'
import useListCompanyFilter from '../../../../elements/Hooks/useListCompanyFilter'
import useModalData, { MODAL_TYPE_EDIT, MODAL_TYPE_NEW } from '../../../../elements/Hooks/useModalData'
import useModalShow from '../../../../elements/Hooks/useModalShow'
import useSubmit from '../../../../elements/Hooks/useSubmit'
import useTitle from '../../../../elements/Hooks/useTitle'
import { get, uniqBy } from 'lodash'
import React, { useState } from 'react'
import { withRouter } from 'react-router-dom'

AddDeliveryOrderCont.propTypes = {}
const templateApi = new Templates()
const emailApi = new Email()

function AddDeliveryOrderCont(props) {
  const key = get(props.match, 'params.key')

  const {
    visible,
    modalType,
    object: delivery,
    setObject: setDelivery,
    submitting,
    submit,
    removing,
    remove,
    formRef,
    onShow,
    onCancel,
    update,
    fetching,
    fetchObject: fetch,
  } = useModalData(
    DeliveryOrderApi.create,
    DeliveryOrderApi.update,
    DeliveryOrderApi.remove,
    undefined,
    key,
    DeliveryOrderApi.read,
    (key) => {
      props.history.replace({
        pathname: `/purchasing/delivery/${key}/update`,
      })
    },
    () => {
      props.history.replace({
        pathname: `/purchasing/delivery/list/`,
      })
    }
  )

  const { actions, fetchingActions, fetchActions, submittingOperation, submitOperation, handleActions } = useActions(
    'delivery',
    delivery,
    setDelivery,
    DeliveryOrderApi.operation
  )

  const type = key ? MODAL_TYPE_EDIT : MODAL_TYPE_NEW
  const isNew = type === MODAL_TYPE_NEW
  useTitle(delivery.code === undefined ? `Create New Delivery Order` : `${delivery.code} Delivery Order`)

  const isUpdatable = isNew ? true : actions.find((a) => a.key === 'update')

  const { list: OrdersList, fetching: fetchingOrders, fetch: fetchOrders } = useFetchList(() =>
    OrdersApi.getOrdersByDeliveryOrder(key)
  )

  const cachedListOrders = OrdersList.filter((o) => o.category === 'Freight' || o.type === 'Freight Booking')

  const { list: _listOrders, company: companyOrder, onChangeCompany: onChangeCompanyOrder } = useListCompanyFilter(
    cachedListOrders,
    fetchingOrders
  )

  const listOrders = uniqBy(_listOrders, '_id')

  const [_3, submitTemplate] = useSubmit(templateApi.read, true)
  const [_1, submitDOTemplate] = useSubmit(emailApi.deliveryOrderTemplate, true)
  const [_2, submitDOFiles] = useSubmit(DeliveryOrderApi.files, true)
  const [_4, getListLine] = useSubmit(DeliveryOrderApi.getLinesByDelivery, true)

  const [emailTemplate, setEmailTemplate] = useState('')
  const [emailDetails, setEmailDetails] = useState('')
  const [emailFiles, setEmailFiles] = useState([])
  const [emailLines, setEmailLines] = useState([])

  const { visible: visibleEmail, onShow: onShowEmail, onCancel: onCancelEmail } = useModalShow(async () => {
    let hide = message.loading('Fetching Email Template ...', 0)
    const listLine = await getListLine(delivery._key)
    const emailLines = listLine.map((i) => ({
      _id: i._id,
      _key: i._key,
      no: i.no,
      name: i.name,
      unit: i.unit,
      delivered: i.delivered,
    }))
    setEmailLines(emailLines)
    console.log({ delivery, listLine })
    const company = get(delivery, 'company._id', '').replace('members/', '')
    const tranTemplate = await submitTemplate(company, 'deliveryOrder')
    const emailDetails = get(tranTemplate, 'email') || {}
    const data = await submitDOTemplate({
      receiver: get(delivery, 'clientRep.fn'),
      companyRep: get(delivery, 'companyRep.fn'),
      company: get(delivery, 'company.fn'),
      code: get(delivery, 'code'),
      salesCode: get(delivery, 'sales.code'),
      lines: emailLines,
      ...emailDetails,
    })

    const filesList = await submitDOFiles([delivery._id])
    setEmailFiles(filesList)
    const filesMapped = filesList.map((f) => f.uuid)
    setEmailTemplate(data.html)
    setEmailDetails({
      to: get(delivery, 'clientRep.email.label'),
      cc: get(emailDetails, 'cc'),
      bcc: get(emailDetails, 'bcc'),
      from: get(emailDetails, 'from'),
      subject: `[${get(delivery, 'code')}] ${get(emailDetails, 'subject')}`,
      attachments: filesMapped,
    })
    hide()
  })

  return (
    <AddDeliveryOrder
      {...{
        type,
        visible,
        modalType,
        delivery,
        submitting,
        submit,
        removing,
        remove,
        formRef,
        onShow,
        onCancel,
        update,
        isNew,
        actions,
        fetchingActions,
        fetchActions,
        submittingOperation,
        submitOperation,
        handleActions,
        fetching,
        fetch,
        isUpdatable,
        OrdersList,
        fetchingOrders,
        fetchOrders,
        cachedListOrders,
        listOrders,
        companyOrder,
        onChangeCompanyOrder,
        onShowEmail,
        visibleEmail,
        onCancelEmail,
        emailTemplate,
        emailDetails,
        emailFiles,
        emailLines,
      }}
    />
  )
}

export default withRouter(AddDeliveryOrderCont)
